(function () {
  var controllerId = "vehiclesController";
  angular
    .module("app")
    .controller(controllerId, ["$rootScope", "$scope", "$location", "moment", "vehicleService", "routeService", "mapService", "alkGeocodeService", "$window", "UserProvider",
      function vehiclesController($rootScope, $scope, $location, moment, vehicleService, routeService, mapService, alkGeocodeService, $window, userProvider) {
        $scope.isInit = false;
        $scope.showVehicles = false;
        $scope.isVehiclesCollapsed = true;
        $scope.userIsAdmin = userProvider.getUser().isAdmin;
        $scope.opt = {
          region: userProvider.getUser().region,
          dataset: userProvider.getUser().dataset
        };
        $scope.showSearch = false;
        $scope.filterVehicles = function () {
          $scope.showSearch = !$scope.showSearch;
        };

        $scope.hasRoutes = function () {
          return routeService.getSelectedRoute() !== null;
        };

        $scope.getVehicleList = function () {
          return $scope.vehicleList;
        };

        $scope.toggleVehicles = function () {
          $scope.isVehiclesCollapsed = !$scope.isVehiclesCollapsed;
        };

        $scope.closeVehicles = function () {
          $scope.showVehicles = false;
          vehicleService.hideVehicles();
        };

        $scope.getVehicleAddressString = function (address) {
          if (!address) {
            return "Location Unknown";
          }

          return _.reject([address.City, address.State], _.isEmpty).join(", ");
        }

        var getVehicleAddress = function (vehicle) {
          if (!vehicle.Latitude && !vehicle.Longitude) {
            vehicle.Address = null;
            return;
          }

          alkGeocodeService.reverseGeocode({
              "lat": vehicle.Latitude,
              "lon": vehicle.Longitude
            }, $scope.opt)
            .then(function (data) {
              vehicle.Address = data[0].Address;
            });
        };

        $scope.refreshVehicles = function () {
          $scope.isLoadingVehicles = true;
          vehicleService.getVehicleList().then(function (results) {
            $scope.vehicleList = results;
            vehicleService.showAllVehicles();
            $scope.isLoadingVehicles = false;
            for (var i = 0; i < $scope.vehicleList.length; i++) {
              getVehicleAddress($scope.vehicleList[i]);
            }
          });
        };

        $scope.frameAll = function () {
          vehicleService.frameAllVehicles();
        };

        function showVehiclePanel() {
          vehicleService.getAccountShortcode().then(function (results) {
            $scope.shortcode = results;
          });
          $scope.refreshVehicles();
        }

        function hideVehiclePanel() {
          vehicleService.hideVehicles();
        }

        $scope.$on("toggleVehicles", () => {
          $scope.showVehicles = !$scope.showVehicles;
          if (!$scope.isInit) {
            vehicleService.createVehicleLayer();
            $scope.isInit = !$scope.isInit;
          }
          if ($scope.showVehicles) {
            showVehiclePanel();
          } else {
            hideVehiclePanel();
          }
        });

        $scope.selectVehicle = function (vehicle) {
          vehicleService.setSelectedVehicle(vehicle.OwnerID);
        };

        $scope.selectedVehicle = function () {
          return vehicleService.getSelectedVehicle();
        };

        $scope.showLocation = function (vehicle) {
          vehicleService.showVehicle(vehicle, true, $scope);
        };

        $scope.showClosest = function () {
          vehicleService.getClosesttToOrigin();
        };

        $scope.resetShortcode = function (shortcode) {
          vehicleService.resetAccountShortcode(shortcode).then(function (results) {
            $scope.shortcode = results;
          });
        };

        $scope.sendRoute = function (vehicleId) {
          vehicleService.prepareMessage(vehicleId);
        };
      }
    ]);
})();



// WEBPACK FOOTER //
// ./app/vehicle/vehicles.controller.js